var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShakeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shake",
    enableBackground: "new 0 0 512.009 512.009",
    height: 512,
    viewBox: "0 0 512.009 512.009",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m393.255 95.121c-1.888-1.987-4.509-3.112-7.25-3.112h-26.418l16.519-61.651c2.854-10.652-3.491-21.64-14.143-24.493l-19.319-5.177c-5.15-1.381-10.537-.666-15.17 2.008-4.633 2.675-7.944 6.985-9.323 12.133l-20.68 77.18h-61.467c-5.522 0-10 4.477-10 10s4.478 10 10 10h56.108l-8.039 30.001h-146.004l-1.539-30.001h9.474c5.522 0 10-4.477 10-10s-4.478-10-10-10h-20c-2.741 0-5.362 1.125-7.25 3.112s-2.877 4.663-2.737 7.4l20 390.001c.562 10.927 9.341 19.487 19.987 19.487h200c10.648 0 19.428-8.561 19.987-19.488l20.001-390c.14-2.737-.85-5.413-2.737-7.4zm-17.777 16.888-1.539 30.001h-27.75l8.039-30.001zm-38.009-92.003 19.319 5.176-17.906 66.827h-20.706zm-24.652 92.003h20.706l-8.039 30.001h-20.706zm60.097 50.001-1.026 20.001h-231.768l-1.026-20.001zm-16.897 329.487c-.013.252-.09.422-.149.511h-199.727c-.06-.09-.137-.26-.149-.512l-14.845-289.485h229.717z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m319.151 292.012c-.093-.002-.184-.003-.274-.003-5.397 0-9.846 4.302-9.991 9.731l-4.309 159.999c-.149 5.521 4.206 10.117 9.727 10.266.093.002.184.003.274.003 5.397 0 9.846-4.302 9.991-9.731l4.309-159.999c.149-5.521-4.206-10.117-9.727-10.266z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m192.857 292.012c-5.521.149-9.876 4.745-9.727 10.266l4.309 159.999c.146 5.429 4.593 9.731 9.991 9.731.091 0 .183-.001.274-.003 5.521-.149 9.876-4.745 9.727-10.266l-4.309-159.999c-.147-5.521-4.704-9.865-10.265-9.728z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m256.004 292.009c-5.522 0-10 4.477-10 10v159.999c0 5.523 4.478 10 10 10s10-4.477 10-10v-159.999c0-5.523-4.478-10-10-10z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m191.008 112.009c5.522 0 10-4.477 10-10s-4.478-10-10-10h-.008c-5.522 0-9.996 4.477-9.996 10s4.481 10 10.004 10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShakeWhite);
export default __webpack_public_path__ + "static/media/shake-white.1a14e7f9051916399cee4440c06d618f.svg";
export { ForwardRef as ReactComponent };